import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import {Amplify } from "aws-amplify";
import aws_exports from "./aws-exports";
import  { Auth }  from  'aws-amplify' ;
import { AWSIoTProvider } from '@aws-amplify/pubsub';

Amplify.configure(aws_exports);
Auth.configure(aws_exports);

// Auth.currentCredentials().then((info) => {
//   const cognitoIdentityId = info;
// });

// Apply plugin with configuration
Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: 'eu-central-1',
  aws_pubsub_endpoint: 'wss://a1noum0qdmy3bj-ats.iot.eu-central-1.amazonaws.com/mqtt',
}
 ));

// Auth.currentCredentials().then((info) => {
//       // const cognitoIdentityId = info.data.IdentityId;
//       console.log("IdentityId: "+info.identityId);
//       console.log("accessKeyId: "+info.accessKeyId);
//     });

// PubSub.subscribe(['PharaOn/environment/AWS','PharaOn/events/AWS']).subscribe({
//   next: data => console.log('Mensaje Recibido', data),
//   error: error => console.error(error)
// });

// Amplify.configure({
//   // OPTIONAL - if your API requires authentication 
//   Auth: {
//       // REQUIRED - Amazon Cognito Identity Pool ID
//       identityPoolId: 'eu-central-1:82f5e2e0-5932-4694-9c5b-fca2498704de', 
//       // REQUIRED - Amazon Cognito Region
//       region: 'eu-central-1', 
//       // OPTIONAL - Amazon Cognito User Pool ID
//       userPoolId: 'us-east-2_NLDcVwHLM', 
//       // OPTIONAL - Amazon Cognito Web Client ID
//       userPoolWebClientId: '30du5dpc30g12dmucqv8l53031',
//   },
//   API: {
//       endpoints: [
//           {
//               name: "MyAPIGatewayAPI",
//               endpoint: "https://o8p0msp0kd.execute-api.us-east-2.amazonaws.com/beta/"
//           },
//           {
//             name: "MyCustomCloudFrontApi",
//             endpoint: "https://api.my-custom-cloudfront-domain.com",

//         }
//       ]
//   }
// });



if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
